import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { isActionInProgress } from 'selectors';
import { GET_AUTH_PROVIDER_URL } from 'actionTypes';
import * as actions from 'actions';

import OAuthButton from './OAuthButton';

export const PROVIDERS = ['twitter', 'facebook', 'linkedin', 'google'];

class OAuthButtonManager extends PureComponent {
  constructor(props) {
    super(props);
    this.openedWindows = {};
    PROVIDERS.forEach(provider => {
      this.openedWindows[provider] = null;
    });
  }

  componentDidMount = () => {
    window.addEventListener('message', this.handleMessage);
    this.props.getAuthProviderDetails(PROVIDERS);
  };

  componentWillUnmount = () => {
    window.removeEventListener('message', this.handleMessage);
  };

  handleMessage = event => {
    if (
      event.origin === window.location.origin &&
      event.data.type === 'oauth_token_received'
    ) {
      const { provider, url } = event.data;

      // We use window details to provide the auth type since the prop value can
      // change before the message is received (due to user interaction).
      const windowDetails = this.openedWindows[provider];
      if (windowDetails) {
        this.props.sendExternalAuthToken(provider, windowDetails.authType, url);
        this.openedWindows[provider] = null; // Clear the window detail
      }
    }
  };

  openExternalAuthPage = provider => {
    const details = this.props.authProviderUrls[provider] || {};
    if (details.url) {
      // Store the auth window details for later use
      this.openedWindows[provider] = {
        window: window.open(details.url, '_blank'),
        authType: this.props.authType,
      };
    }
  };

  renderExternalPrivateActionButtons = () => {
    const { buttonTextMap, authProviderUrls } = this.props;
    return PROVIDERS.map((provider, i) => {
      const disabled =
        !authProviderUrls[provider] || !authProviderUrls[provider].url;
      return (
        <OAuthButton
          key={i}
          provider={provider}
          text={buttonTextMap[provider]}
          disabled={disabled}
          onClick={this.openExternalAuthPage}
        />
      );
    });
  };

  render() {
    return (
      <React.Fragment>
        {this.renderExternalPrivateActionButtons()}
      </React.Fragment>
    );
  }
}

OAuthButtonManager.propTypes = {
  buttonTextMap: PropTypes.object.isRequired,
  authType: PropTypes.oneOf(actions.VALID_AUTH_TYPES),
};

function mapStateToProps(state) {
  return {
    token: state.auth.token,
    authProviderUrls: state.authProviderUrls,
    isFetchingAuthUrls: isActionInProgress(state, GET_AUTH_PROVIDER_URL),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getAuthProviderDetails: actions.getAuthProviderDetails,
      sendExternalAuthToken: actions.sendExternalAuthToken,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(OAuthButtonManager);



// WEBPACK FOOTER //
// ./src/Components/Auth/OAuthButtonManager.js